module.exports = __webpack_public_path__ + "img/ICONO1.32fd3ddb.png";